// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/customPage/project-manager/Pages/BaseInfo.scss
// module id = 4140
// module chunks = 50